module.exports = { apiServer: 'https://apiv3.eventizer.hk', AdminServer: 'https://adminv3.eventizer.hk' };
